import { SelfContainedCommand, CommandExecutionContext } from '../../../../types/commands';
import { StandardToolResult, createSuccessResult, createErrorResult } from '../../../../types/standardToolResults';
import { API_BASE_URL } from '../../../../api/config';
import fetchService from '../../../../services/fetchService';

export const automation_delete: SelfContainedCommand = {
  id: 'automation_delete',
  description: `Permanently delete an automation by ID. This also removes any linked cron schedule.

Use automation_list first to confirm the automationId, then delete.`,
  autonomyLevel: 'auto',
  visualTreatment: 'narrative',

  schema: {
    parameters: [
      {
        name: 'automationId',
        type: 'string',
        description: 'The ID of the automation to delete (get this from automation_list)',
        required: true,
        examples: ['automation_20240101_123456'],
      },
    ],
  },

  examples: {
    good: [
      {
        input: { automationId: 'automation_20240101_123456' },
        expectedOutput: createSuccessResult('Automation deleted', { automationId: 'automation_20240101_123456' }),
        description: 'Delete an automation by ID',
      },
    ],
    bad: [
      {
        input: {},
        error: 'automationId is required',
        why: 'Must specify which automation to delete',
        fix: 'Use automation_list to find the automation ID first',
      },
    ],
  },

  handler: async (params: any, _context: CommandExecutionContext): Promise<StandardToolResult> => {
    const { automationId } = params;
    if (!automationId) return createErrorResult('automationId is required', '', 'validation');

    try {
      await fetchService(`${API_BASE_URL}/automations/${automationId}`, { method: 'DELETE' });
      return createSuccessResult(
        `Automation ${automationId} deleted`,
        { automationId },
      );
    } catch (error: any) {
      return createErrorResult('Failed to delete automation', error.message || 'Unknown error', 'execution');
    }
  },
};
